export const iconFontAwesomeWritingPencil = (
	<i className="fa-solid fa-pencil"></i>
);
